import { Loader2, Play, ExternalLink, Layers, AlertTriangle } from "lucide-react";
import { Pill } from "./Pill";
import { FRAMEWORK_META, READINESS_TONE, READINESS_LABEL } from "./constants";

export function FrameworkCard({ framework, running, onRunAssessment, onOpen }) {
  const meta = FRAMEWORK_META[framework.framework_id] || {};
  const score = framework.score || {};
  const rd = score.readiness || "not_assessed";
  return (
    <div className="hw-reg__fw-card" data-testid={`fw-card-${framework.framework_id}`}
         style={{ borderTopColor: meta.accent }}>
      <div className="hw-reg__fw-head">
        <div>
          <div className="hw-reg__fw-name" style={{ color: meta.color }}>
            {framework.short_name}
          </div>
          <div className="hw-reg__fw-full">{framework.name}</div>
        </div>
        <Pill tone={READINESS_TONE[rd]} testId={`fw-readiness-${framework.framework_id}`}>
          {READINESS_LABEL[rd]}
        </Pill>
      </div>
      <div className="hw-reg__fw-score" data-testid={`fw-score-${framework.framework_id}`}>
        <span className="hw-reg__fw-score-num">{score.weighted_score ?? 0}</span>
        <span className="hw-reg__fw-score-pct">%</span>
      </div>
      <div className="hw-reg__fw-meta">
        <span><Layers className="w-3 h-3" /> {score.total_controls || 0} controls</span>
        <span><AlertTriangle className="w-3 h-3" /> {score.gap_count || 0} gaps</span>
      </div>
      <div className="hw-reg__fw-actions">
        <button type="button" className="hw-reg__btn hw-reg__btn--sm"
                onClick={() => onOpen(framework.framework_id)}
                data-testid={`fw-open-${framework.framework_id}`}>
          <ExternalLink className="w-3.5 h-3.5" /> Details
        </button>
        <button type="button" className="hw-reg__btn hw-reg__btn--primary hw-reg__btn--sm"
                onClick={() => onRunAssessment(framework.framework_id)}
                disabled={running === framework.framework_id}
                data-testid={`fw-run-${framework.framework_id}`}>
          {running === framework.framework_id
            ? <Loader2 className="w-3.5 h-3.5 animate-spin" />
            : <Play className="w-3.5 h-3.5" />}
          Run
        </button>
      </div>
    </div>
  );
}
